/**
 * API 응답에서 UserProfile 본문 추출
 * @param {unknown} response
 */
export function extractUserProfile(response) {
  if (!response) {
    return null;
  }
  const body = response.data !== undefined ? response.data : response;
  if (!body || typeof body !== 'object') {
    return null;
  }
  if (body.userId == null && body.id == null && body.seq == null) {
    return null;
  }
  return body;
}
